<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4" id="button_user">
      <h1 class="h3 mb-0 text-gray-800 d-inline-block">Add User</h1>
    </div>
    <div>
      <please-wait-modal/>
      <mitra-profile :data="data_user" @on-save="save" v-if="this.$route.query.type_id == 'MITRA'"/>
      <agent-profile :data="data_user" @on-save="save" v-else-if="this.$route.query.type_id == 'AGENT'"/>
      <profile :data="data_user" @on-save="save" :is_edited="is_edited" v-else/>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

import profile from '@/pages/user/user_component/profile'
import mitra_profile from '@/pages/user/mitra_component/profile'
import agent_profile from '@/pages/user/agent_component/profile'

export default {
  components:{
    profile,
    'mitra-profile': mitra_profile,
    'agent-profile': agent_profile,
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      is_edited: false,
      data_user:{
        name: '',
        gender: '1',
        email: '',
        address: '',
        phone_number: '',
        marital_status: '',
        tribes: '',
        blood_type: '',
        religion: '',
        education: '',
        id_card: '',
        id_card_number: '',
        family_contact: '',
        family_phone: '',
        have_children: false,
        arr_skill: [],
        arr_work_at: [],
        arr_picture: [],
        city: '',
        mitra: '',
        type: {
          id: '',
          name: '',
          createdAt: '',
          updatedAt: '',
        },
      },
    }
  },
  async mounted(){
    await this.get_type()
  },
  methods: {
    async get_type(){
      var response = await axios.get(base_url+'/type?id='+this.$route.query.type_id)

      var response_data = response.data

      if(response_data.status == "success"){
        var data_user = this.data_user
        data_user.type = response_data.data
        this.data_user = Object.assign({},this.data_user,data_user)
      }
      else
        this.$toasted.show(response_data.message)
    },
    async save(data_user){
      try{
        // console.log(this.data_user)
        var total = 0
        var counter = 0
        if(this.$route.query.type_id == 'MITRA'){
          var arr_header = ['name','email','address','phone_number','city']
          total = arr_header.length


          for(let x in arr_header){
            if(data_user[arr_header[x]] == ''){
              this.$toasted.show(arr_header[x].replace(/_/g,' ')+" is empty")
              break
            }
            counter++
          }
        }
        else if(this.$route.query.type_id == 'AGENT'){
          var arr_header = ['name','mitra','id_card_number','phone_number']
          total = arr_header.length

          for(let x in arr_header){
            if(data_user[arr_header[x]] == ''){
              this.$toasted.show(arr_header[x].replace(/_/g,' ')+" is empty")
              break
            }
            counter++
          }
        }
        else{
          var arr_header = this.data_user.type.name == "Helper" ? ['name','gender','city','birth_date','email','address','phone_number','weight','height','marital_status','tribes','blood_type','religion','education','weight','height','helper_sub_category','requested_price','salary_type','could_live_in','is_afraid_dog','have_work_abroad','is_understood_english','arr_picture','selected_skill','selected_work_at','id_card_number','id_card'] : (this.data_user.type.name == "Majikan" ? ['name','gender','city','birth_date','email','address','phone_number','marital_status','tribes','religion','have_children','arr_picture','id_card_number','id_card'] : ['name','gender','email','address','phone_number'])
          total = arr_header.length
          var counter = 0


          for(let x in arr_header){
            // console.log(data_user[arr_header[x]] != false && data_user[arr_header[x]] != true)
            if((!Array.isArray(data_user[arr_header[x]]) && (data_user[arr_header[x]] == '' || data_user[arr_header[x]] == null) && typeof data_user[arr_header[x]] != 'number') || (Array.isArray(data_user[arr_header[x]]) && data_user[arr_header[x]].length == 0)){
              this.$toasted.show(arr_header[x].replace(/arr_/g,'').replace(/selected_/g,'').replace(/_/g,' ')+" is empty")
              break
            }
            counter++
          }
        }

        if(counter == total){
          $('#please_wait_modal').modal('show')
          var data = JSON.parse(JSON.stringify(data_user))
          if(this.$route.query.type_id != 'MITRA' && this.$route.query.type_id != 'AGENT' && data_user.type.name != 'Operator'){
            for(let x in data.arr_picture)
              data.arr_picture[x].picture = await image2base64(data.arr_picture[x].picture)
            if(data.id_card != null)
              data.id_card = await image2base64(data.id_card)
            data.city = {
              id: data_user.city
            }
            data.helper_sub_category = {
              id: data_user.helper_sub_category
            }
            data.birth_place = {
              id: data_user.birth_place
            }
          }
          else if(this.$route.query.type_id == 'MITRA'){
            if(data.picture != null)
              data.picture = await image2base64(data.picture)
          }
          data.phone = data_user.phone_number
          if(this.$route.query.type_id != 'MITRA' && this.$route.query.type_id != 'AGENT' && data_user.type.name != 'Operator')
            data.requested_price = parseFloat(data_user.requested_price.replace(/\./g,'').replace(/,/g,''))
          data.gender = data_user.gender == true ? '1' : '0'
          data.type = {
            id: this.$route.query.type_id
          }
          data.city = {
            id: data_user.city
          }
          data.mitra = {
            id: data_user.mitra
          }
          data.marital_status = {
            id: data_user.marital_status
          }
          data.blood_type = {
            id: data_user.blood_type
          }
          data.religion = {
            id: data_user.religion
          }
          data.tribe = {
            id: data_user.tribes
          }
          data.education = {
            id: data_user.education
          }

          var response = await axios.post(base_url+(this.$route.query.type_id == 'MITRA' ? '/mitra' : (this.$route.query.type_id == 'AGENT' ? '/agent' : '/user')),data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data

          if(response_data.status == "success"){
            location.href = "/user"
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    }
  }
}
</script>
